import theme from 'theme'
import Text from 'components/common/Text'

export function PanelSection(props) {
  return <section {...props} />
}

export const PanelHeader = props => (
  <section
    css={{
      display: 'flex',
      alignItems: 'center',
      paddingBottom: theme.space[3],
      borderBottom: theme.border.base,
      height: 48
    }}
    {...props}
  />
)

export const PanelTitle = props => <Text as="h3" color="medium" {...props} />

export const PanelDetails = props => (
  <section css={{ marginTop: theme.space[4], width: '100%' }} {...props} />
)

export const PanelDetailsGrid = props => (
  <PanelDetails
    css={{
      display: 'grid',
      gridTemplateColumns: 'fit-content(160px) 1fr',
      gap: theme.space[3],
      gridColumnGap: theme.space[4]
    }}
    {...props}
  />
)

export const PanelRow = props => (
  <div
    css={{
      marginBottom: theme.space[3],
      display: 'grid',
      gridTemplateColumns: '160px 1fr',
      gap: theme.space[3],
      fontWeight: theme.fontWeights[1],
      wordBreak: 'break-word'
    }}
    {...props}
  />
)

export function Label(props) {
  return <Text as="span" color="normal" {...props} />
}

export function Value(props) {
  return (
    <Text
      as="span"
      color="dark"
      css={{ wordBreak: 'break-word' }}
      weight="normal"
      {...props}
    />
  )
}
